import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import BrightnessAutoOutlinedIcon from '@mui/icons-material/BrightnessAutoOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useColorMode } from '../theme/AppThemeProvider';

const ThemeToggle = () => {
  const { preference, setPreference } = useColorMode();

  return (
    <ToggleButtonGroup
      value={preference}
      exclusive
      onChange={(_, value) => {
        if (value != null) setPreference(value);
      }}
      size="small"
      aria-label="Theme: system, light, or dark"
      sx={{
        ml: 1,
        '& .MuiToggleButton-root': {
          px: 0.75,
          py: 0.25,
          border: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Tooltip title="Match system appearance">
        <ToggleButton value="system" aria-label="Match system appearance">
        <BrightnessAutoOutlinedIcon fontSize="small" />
      </ToggleButton>
      </Tooltip>
      <Tooltip title="Light theme">
        <ToggleButton value="light" aria-label="Light theme">
          <LightModeOutlinedIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Dark theme">
        <ToggleButton value="dark" aria-label="Dark theme">
          <DarkModeOutlinedIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ThemeToggle;
